import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";

export default class DashboardConsolExclutionsTempUnable extends Component {
  render() {
    return (
      <>
        <h2
          style={{
            height: "300px",
            lineHeight: "300px",
            textAlign: "center",
          }}
        >
          CONSOLIDADO DESACTIVADO TEMPORALMENTE
        </h2>
      </>
    );
  }
}
